const DASHED_SUFFIX = '--dashed';

export const parseDashedColor = (color: string) => {
  if (!color?.includes(DASHED_SUFFIX)) {
    return { color, dashed: false };
  }

  return { color: color?.slice(0, color?.indexOf(DASHED_SUFFIX)), dashed: true };
};
